import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["disabled", "options", "multiple", "internalValue", "blurInput", "setIsOptionListShown", "onValueUpdate", "onChange", "setInternalValue", "internalOptions", "dynamicInternalOptions", "setInternalOptions", "setSearch", "enableSelectAllOption", "selectAllLabel", "enableSearchOption", "searchPlaceholder", "enableFooter", "onCancelClick", "onConfirmClick", "footerContent", "defaultSearchQuery", "enableVirtualization", "isFlat", "groups", "enableOptionContentEllipsis"];
import "core-js/modules/es.array.reduce.js";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { OPTION_LIST_ITEM } from '../constants';
import { useOnToggleAll } from '../../Dropdown/hooks';
import { useOnSearchQueryChange } from './useOnSearchQueryChange';
import { useVirtualization } from '../../../system';
export var useOptionList = function useOptionList(_ref) {
  var disabled = _ref.disabled,
      options = _ref.options,
      multiple = _ref.multiple,
      internalValue = _ref.internalValue,
      blurInput = _ref.blurInput,
      setIsOptionListShown = _ref.setIsOptionListShown,
      onValueUpdate = _ref.onValueUpdate,
      onChange = _ref.onChange,
      setInternalValue = _ref.setInternalValue,
      internalOptions = _ref.internalOptions,
      _ref$dynamicInternalO = _ref.dynamicInternalOptions,
      dynamicInternalOptions = _ref$dynamicInternalO === void 0 ? internalOptions : _ref$dynamicInternalO,
      setInternalOptions = _ref.setInternalOptions,
      setSearch = _ref.setSearch,
      enableSelectAllOption = _ref.enableSelectAllOption,
      _ref$selectAllLabel = _ref.selectAllLabel,
      selectAllLabel = _ref$selectAllLabel === void 0 ? 'Select all' : _ref$selectAllLabel,
      enableSearchOption = _ref.enableSearchOption,
      _ref$searchPlaceholde = _ref.searchPlaceholder,
      searchPlaceholder = _ref$searchPlaceholde === void 0 ? 'Search' : _ref$searchPlaceholde,
      enableFooter = _ref.enableFooter,
      onCancelClick = _ref.onCancelClick,
      onConfirmClick = _ref.onConfirmClick,
      footerContent = _ref.footerContent,
      _ref$defaultSearchQue = _ref.defaultSearchQuery,
      defaultSearchQuery = _ref$defaultSearchQue === void 0 ? '' : _ref$defaultSearchQue,
      _ref$enableVirtualiza = _ref.enableVirtualization,
      enableVirtualization = _ref$enableVirtualiza === void 0 ? false : _ref$enableVirtualiza,
      isFlat = _ref.isFlat,
      groups = _ref.groups,
      enableOptionContentEllipsis = _ref.enableOptionContentEllipsis,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(defaultSearchQuery),
      _useState2 = _slicedToArray(_useState, 2),
      searchQuery = _useState2[0],
      setSearchQuery = _useState2[1];

  var listContainerRef = useRef(null);
  var listRef = useRef(null);

  var _useVirtualization = useVirtualization(enableVirtualization, listRef, dynamicInternalOptions, {
    itemSelector: '.OptionListItem-Root',
    parentContainerRef: listContainerRef
  }),
      virtualData = _useVirtualization.data,
      virtualBottomOffset = _useVirtualization.bottomOffset,
      virtualTopOffset = _useVirtualization.topOffset;

  useEffect(function () {
    if (setSearch) {
      setSearch(searchQuery);
    }
  }, [searchQuery, setSearch]);
  var onSearchChange = useOnSearchQueryChange(internalValue, internalOptions, setInternalOptions, setSearch, searchQuery, enableSearchOption);

  var resetListState = function resetListState() {
    setSearchQuery('');
    onSearchChange();
  };

  var onOptionSelect = useCallback(function (item) {
    if (internalOptions) {
      onValueUpdate(internalValue, multiple, item, item.value, options, isFlat);
    }

    if (!multiple) {
      setIsOptionListShown(false);
      resetListState();
    }

    if (blurInput) {
      blurInput();
    }
  }, [internalOptions, onValueUpdate, internalValue, multiple, options, isFlat, blurInput, setSearchQuery]);
  var onToggleAll = useOnToggleAll(setInternalValue, internalOptions, internalValue, onChange);
  useEffect(function () {
    return onSearchChange();
  }, [searchQuery]);

  var handleToggleAll = function handleToggleAll() {
    return onToggleAll();
  };

  var handleSearchChange = useCallback(function (event) {
    var newSearchQuery = event.target.value || '';
    setSearchQuery(newSearchQuery);
  }, [setSearchQuery, setSearchQuery]);
  var selectAllCheckedIcon = internalOptions.length === internalValue.length ? 'tick' : 'dash';
  var groupIndex = useMemo(function () {
    if (!groups || !groups.length) {
      return {};
    }

    return groups.reduce(function (result, group) {
      result[group.id] = group;
      return result;
    }, {});
  }, [groups]);

  var handleCancelButtonClick = function handleCancelButtonClick() {
    setIsOptionListShown(false);

    if (onCancelClick) {
      onCancelClick();
    }
  };

  var handleConfirmButtonClick = function handleConfirmButtonClick() {
    setIsOptionListShown(false);

    if (onConfirmClick) {
      onConfirmClick();
    }
  };

  var selectAllItem = useMemo(function () {
    return {
      value: -1,
      label: selectAllLabel
    };
  }, [selectAllLabel]);
  return {
    rootProps: restProps,
    getOptionItemProps: function getOptionItemProps(option) {
      return {
        'data-testid': OPTION_LIST_ITEM,
        isSelected: internalValue.includes(option.value),
        item: option,
        key: option.value,
        onOptionSelect: onOptionSelect,
        multiple: multiple,
        enableContentEllipsis: enableOptionContentEllipsis
      };
    },
    getSelectAllItemProps: function getSelectAllItemProps() {
      return {
        item: selectAllItem,
        checkedIcon: selectAllCheckedIcon,
        isSelected: internalValue.length > 0,
        onOptionSelect: handleToggleAll,
        multiple: multiple
      };
    },
    getOptionListSearchProps: function getOptionListSearchProps() {
      return {
        placeholder: searchPlaceholder,
        onChange: handleSearchChange,
        defaultQuery: searchQuery
      };
    },
    listContainerProps: {
      ref: listContainerRef
    },
    listProps: {
      ref: listRef
    },
    enableVirtualization: enableVirtualization,
    getVirtualTopSpaceProps: function getVirtualTopSpaceProps() {
      return {
        height: virtualTopOffset
      };
    },
    getVirtualBottomSpaceProps: function getVirtualBottomSpaceProps() {
      return {
        height: virtualBottomOffset
      };
    },
    internalOptions: internalOptions,
    dynamicInternalOptions: enableVirtualization && virtualData && virtualData.length ? virtualData : dynamicInternalOptions,
    disabled: disabled,
    internalValue: internalValue,
    multiple: multiple,
    enableSelectAllOption: enableSelectAllOption,
    enableSearchOption: enableSearchOption,
    isOptionListHeaderRendered: enableSelectAllOption || enableSearchOption,
    isFooterRendered: enableFooter || footerContent,
    optionListFooterProps: {
      footerContent: footerContent,
      onCancelClick: handleCancelButtonClick,
      onConfirmClick: handleConfirmButtonClick
    },
    isSelectAllOptionRendered: enableSelectAllOption && multiple && !searchQuery,
    groupIndex: groupIndex
  };
};